import React from 'react';
import '../../styles/MembershipDashboard.css';
import { FaUserCircle } from 'react-icons/fa'; // Example icon

function MembershipDashboard() {
  return (
    <div className="membership-dashboard">
      <h2>MEMBERSHIP DASHBOARD</h2>
      <div className="profile-info">
        <div className="avatar">
          <FaUserCircle size={80} color="#777" />
        </div>
        <div className="name">
          <h3>NAME & SURNAME</h3>
        </div>
      </div>
      <div className="details">
        <div className="detail-item">
          <label>Group Name</label>
          <div className="value">Group allocated to the user</div>
        </div>
        <div className="detail-item">
          <label>Student ID</label>
          <div className="value">The unique number allocated to the student</div>
        </div>
        <div className="detail-item">
          <label>Level</label>
          <div className="value">The level in which the student is enrolled</div>
        </div>
      </div>
    </div>
  );
}

export default MembershipDashboard;